module.exports = __webpack_public_path__ + "img/cyyd_bg1.d9bd0478.png";